/*=========================================================================================
  File Name: modulePartenaireState.js
  Description: Partenaire Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  partenaires: []
}
